import { render } from "./Ekonomi.vue?vue&type=template&id=d989a42c"
import script from "./Ekonomi.vue?vue&type=script&lang=js"
export * from "./Ekonomi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__